export default __webpack_public_path__ + "static/scam-alert-image-1-dab317c884157b6edb37c2e2e7dd177b.webp";